import { FC, useRef, useState } from "react";
import { SurveyPostObject } from "../../service/apiHelper";

const testForNumber = (value: string) => {
  const re = /^[0-9\b]+$/;
  if (value === "" || re.test(value)) {
    return true;
  } else {
    return false;
  }
};
//TODO: Add is required indicator
export interface textProps {
  label?: string;
  id: string;
  errorLabel?: string;
  type: string;
  defaultValue: string;
  placeHolder: string;
  disabled: boolean;
}

export enum TEXT_INPUT_SIZE {
  full = "col-span-full",
  span1 = "sm:col-span-1",
  span2 = "sm:col-span-2",
  span3 = "sm:col-span-3",
  span4 = "sm:col-span-4",
  span5 = "sm:col-span-5",
}

export const TextInput: FC<{
  label?: string;
  id: string;
  errorLabel?: string;
  type?: string;
  defaultValue?: string;
  placeHolder?: string;
  disabled?: boolean;
  required?: boolean;
  pattern?: string;
  span?: TEXT_INPUT_SIZE;
  checkValidation?: boolean;
  name: string;
  handleChange: Function;
}> = (props) => {
  let refValue = useRef<HTMLInputElement | null>(null);

  const [showError] = useState(false);
  const [value, setValue] = useState("");

  const onChangeHandler = (event: React.FormEvent<HTMLInputElement>) => {
    if (props.type === "tel") {
      if (testForNumber(event.currentTarget.value)) {
        setValue(event.currentTarget.value);

        const newProps: SurveyPostObject = {
          SurveyId: props.id,
          SurveyLabel: props.name,
          ResponseText: event.currentTarget.value,
          ResponseValue: event.currentTarget.value,
        };

        props.handleChange(newProps);
      }
    } else {
      setValue(event.currentTarget.value);

      const newProps: SurveyPostObject = {
        SurveyId: props.id,
        SurveyLabel: props.name,
        ResponseText: event.currentTarget.value,
        ResponseValue: event.currentTarget.value,
      };

      props.handleChange(newProps);
    }
  };

  return (
    <div className={props.span}>
      <label
        htmlFor={props.id}
        className="block text-sm font-normal leading-6 text-gray-900"
      >
        {props.label}
        {props.required && <span className="text-error-600">*</span>}
      </label>
      <div className="mt-2">
        <input
          onChange={onChangeHandler}
          value={value}
          type={props.type}
          name={props.name}
          id={props.id}
          pattern={props.pattern}
          defaultValue={props.defaultValue}
          placeholder={props.placeHolder}
          disabled={props.disabled}
          required={props.required}
          className="block w-full rounded-md border-0 py-1.5 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary-600 sm:text-sm sm:leading-6"
        />
      </div>
      {showError ||
        (props.checkValidation && refValue.current?.value === "" && (
          <p className="mt-1 text-xs text-error-600">{props.errorLabel}</p>
        ))}
    </div>
  );
};

export const BaseTextInput: FC<{
  label?: string;
  id: string;
  errorLabel?: string;
  type?: string;
  defaultValue?: string;
  placeHolder?: string;
  disabled?: boolean;
  required?: boolean;
  pattern?: string;
  span?: TEXT_INPUT_SIZE;
  checkValidation?: boolean;
  name: string;
  handleChange: Function;
}> = (props) => {
  let refValue = useRef<HTMLInputElement | null>(null);
  const [value, setValue] = useState("");

  const onChangeHandler = (event: React.FormEvent<HTMLInputElement>) => {
    if (props.type === "tel") {
      if (testForNumber(event.currentTarget.value)) {
        setValue(event.currentTarget.value);
        props.handleChange(event.currentTarget.value);
      }
    } else {
      setValue(event.currentTarget.value);
      props.handleChange(event.currentTarget.value);
    }
  };

  return (
    <div className={props.span}>
      <label
        htmlFor={props.id}
        className="block text-sm font-normal leading-6 text-gray-900"
      >
        {props.label}
        {props.required && <span className="text-error-600">*</span>}
      </label>
      <div className="mt-2">
        <input
          onChange={onChangeHandler}
          value={value}
          ref={refValue}
          type={props.type}
          name={props.name}
          id={props.id}
          pattern={props.pattern}
          defaultValue={props.defaultValue}
          placeholder={props.placeHolder}
          disabled={props.disabled}
          required={props.required}
          className="block w-full rounded-md border-0 py-1.5 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary-600 sm:text-sm sm:leading-6"
        />
      </div>
      {/* {showError ||
        (props.checkValidation && refValue.current?.value === "" && (
          <p className="mt-1 text-xs text-error-600">{props.errorLabel}</p>
        ))} */}
    </div>
  );
};

TextInput.defaultProps = {
  type: "text",
  span: TEXT_INPUT_SIZE.span1,
};

BaseTextInput.defaultProps = {
  type: "text",
  span: TEXT_INPUT_SIZE.span1,
};

export const TextArea: FC<{
  label?: string;
  id: string;
  errorLabel?: string;
  type?: string;
  defaultValue?: string;
  placeHolder?: string;
  disabled?: boolean;
  required?: boolean;
  span: TEXT_INPUT_SIZE;
  checkValidation?: boolean;
  name: string;
  handleChange: Function;
}> = (props) => {
  let refValue = useRef<HTMLTextAreaElement | null>(null);
  const [showError] = useState(false);

  const [value, setValue] = useState("");

  const onChangeHandler = (event: React.FormEvent<HTMLTextAreaElement>) => {
    setValue(event.currentTarget.value);

    const newProps: SurveyPostObject = {
      SurveyId: props.id,
      SurveyLabel: props.name,
      ResponseText: event.currentTarget.value,
      ResponseValue: event.currentTarget.value,
    };

    props.handleChange(newProps);
  };
  return (
    <div className={props.span}>
      <label
        htmlFor={props.label}
        className="block text-sm font-normal leading-6 text-gray-900"
      >
        {props.label}
        {props.required && <span className="text-error-600">*</span>}
      </label>
      <div className="mt-2">
        <textarea
          onChange={onChangeHandler}
          value={value}
          rows={4}
          name={props.name}
          id={props.id}
          defaultValue={props.defaultValue}
          placeholder={props.placeHolder}
          disabled={props.disabled}
          required={props.required}
          //   autoComplete="given-name"
          className="block w-full rounded-md border-0 py-1.5 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary-600 sm:text-sm sm:leading-6"
        />
        {showError ||
          (props.checkValidation && refValue.current?.value === "" && (
            <p className="mt-1 text-xs text-error-600">{props.errorLabel}</p>
          ))}
      </div>
    </div>
  );
};

export const NumberInput: FC<{
  label?: string;
  id: string;
  errorLabel?: string;
  defaultValue?: string;
  placeHolder?: string;
  disabled?: boolean;
  required?: boolean;
  pattern?: string;
  span?: TEXT_INPUT_SIZE;
}> = (props) => {
  const [value, setValue] = useState("");
  return (
    <div className={props.span}>
      <label
        htmlFor={props.label}
        className="block text-sm font-normal leading-6 text-gray-900"
      >
        {props.label}
      </label>
      <div className="mt-2">
        <input
          type="number"
          name={props.label}
          id={props.id}
          pattern="[0-9]*"
          defaultValue={props.defaultValue}
          placeholder={props.placeHolder}
          disabled={props.disabled}
          required={props.required}
          value={value}
          onChange={(e) =>
            setValue((v) => (e.target.validity.valid ? e.target.value : v))
          }
          //   autoComplete="given-name"
          className="block w-full rounded-md border-0 py-1.5 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary-600 sm:text-sm sm:leading-6"
        />
      </div>
    </div>
  );
};
